import {
  createAsyncThunk,
  createSlice,
  createListenerMiddleware,
  type TypedStartListening,
} from "@reduxjs/toolkit"
import { keycloakInstance } from "../../../shared/libs/keycloack/config"
import { invalidateAccessToken } from "../../../shared/api/invalidateTokenEvent"
import { AppDispatch, RootState } from "../../../app/store"

export const logoutThunk = createAsyncThunk<void, void, { state: RootState }>(
  "user/logout",
  async (_: unknown, { dispatch }) => {
    dispatch(removeActiveUser())
  },
)

export const invalidateAccessTokenListener = createListenerMiddleware()
export type TypedListening = TypedStartListening<RootState, AppDispatch>
export const startInvalidateAccessTokenListener =
  invalidateAccessTokenListener.startListening as TypedListening

startInvalidateAccessTokenListener({
  actionCreator: invalidateAccessToken,
  effect: async (_, api) => {
    keycloakInstance.logout()
    api.dispatch(logoutThunk())
  },
})

export interface IUsersState {
  token: string
}

const initialState: IUsersState = {
  token: "",
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    removeActiveUser(state) {
      state.token = ""
    },
    setToken(state, action) {
      state.token = action.payload
    },
  },
})

export const { removeActiveUser, setToken } = userSlice.actions
export const userReducer = userSlice.reducer
